import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";
import { INSURANCE_TYPES } from "../lib/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const inputCls =
  "w-full rounded-xl border border-navy/10 bg-white px-4 py-3.5 text-sm text-navy placeholder:text-charcoal/40 outline-none transition-colors duration-200 focus:border-mint focus:ring-2 focus:ring-mint/20";

export default function QuoteForm({ defaultType = "" }) {
  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    insurance_type: defaultType,
    city: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/enquiries`, form);
      toast.success("Enquiry received! Our team will reach out to you shortly.");
      setForm({ name: "", phone: "", email: "", insurance_type: defaultType, city: "", message: "" });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong. Please try again or call us.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="grid gap-4 sm:grid-cols-2" data-testid="quote-form">
      <input required minLength={2} placeholder="Full Name" value={form.name} onChange={set("name")} className={inputCls} data-testid="quote-form-name" aria-label="Full Name" />
      <input required type="tel" minLength={10} placeholder="Mobile Number" value={form.phone} onChange={set("phone")} className={inputCls} data-testid="quote-form-phone" aria-label="Mobile Number" />
      <input required type="email" placeholder="Email Address" value={form.email} onChange={set("email")} className={inputCls} data-testid="quote-form-email" aria-label="Email Address" />
      <select required value={form.insurance_type} onChange={set("insurance_type")} className={`${inputCls} ${form.insurance_type ? "" : "text-charcoal/40"}`} data-testid="quote-form-insurance-type" aria-label="Select Insurance Type">
        <option value="" disabled>Select Insurance Type</option>
        {INSURANCE_TYPES.map((t) => (
          <option key={t} value={t}>{t}</option>
        ))}
      </select>
      <input required minLength={2} placeholder="City" value={form.city} onChange={set("city")} className={inputCls} data-testid="quote-form-city" aria-label="City" />
      <input placeholder="Message / Requirement (optional)" value={form.message} onChange={set("message")} className={inputCls} data-testid="quote-form-message" aria-label="Message or Requirement" />
      <div className="sm:col-span-2">
        <button
          type="submit"
          disabled={loading}
          className="group flex w-full items-center justify-center gap-2 rounded-full bg-mint py-4 text-base font-bold text-white shadow-mint transition-all duration-200 hover:-translate-y-0.5 hover:bg-mint-600 disabled:opacity-60"
          data-testid="quote-form-submit"
        >
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <Send className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />}
          {loading ? "Sending..." : "Request a Quote"}
        </button>
        <p className="mt-3 text-center text-xs text-charcoal/50" data-testid="quote-form-privacy-note">
          Your information will be used to respond to your enquiry and provide relevant assistance.
        </p>
      </div>
    </form>
  );
}
